export const ROLE_GLOBAL = 'ROLE_GLOBAL';
export const ROLE_UPLOADER_LOCAL = 'ROLE_UPLOADER_LOCAL';
export const ROLE_UPLOADER_GLOBAL = 'ROLE_UPLOADER_GLOBAL';
export const ROLE_SAVE_SEARCH_ADMINISTRATOR = 'ROLE_SAVESEARCH_ADMINISTRATOR';
export const ROLE_INTERNAL = 'ROLE_INTERNAL';
export const ROLE_EXTERNAL = 'ROLE_EXTERNAL';

export const ROLE_MYTOOLBOX_ADMINISTRATOR = 'ROLE_MYTOOLBOX_ADMINISTRATOR';
